import script from "./DialogIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogIndex.vue?vue&type=script&setup=true&lang=js"

import "./DialogIndex.vue?vue&type=style&index=0&id=ec97b044&lang=css"

const __exports__ = script;

export default __exports__